export class ParticaSubItem {
	public name: string = "";
	public id: string = "0";
	public parentid: string = "";
	public icon: string = "";
	public optional: string = "";
}

// tslint:disable-next-line: max-classes-per-file
export class ParticaItem {
	public name: string = "";
	public id: string = "0";
	public items: ParticaSubItem[] = [];
	public children: ParticaSubItem[] = [];
	public open: boolean = false;
}

// tslint:disable-next-line: max-classes-per-file


// tslint:disable-next-line: max-classes-per-file
export class ParticaDropEvent {
	public dragtype: eParticaDragType;
	public destination: any;
	public source: any;
}

export enum eParticaDragType {
	one,
	many,
	all
}
